import { formatAud } from '@/pages/blueprint-lite/utils/formatters';

import type { PurchaseAssessmentResult } from '../../../assessment/types';
import s from '../styles/dashboard.module.css';

const VERDICT_CFG = {
  green: { className: s.verdictGreen, label: 'Ready' },
  amber: { className: s.verdictAmber, label: 'In review' },
  red: { className: s.verdictRed, label: 'Action required' },
} as const;

const today = new Date().toLocaleDateString('en-AU', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
});

interface Props {
  result: PurchaseAssessmentResult;
  applicationId: string;
}

const BlueprintHeader = ({ result, applicationId }: Props) => {
  const cfg = VERDICT_CFG[result.status];
  const { applicant, purchase } = result.input;
  const fullName =
    `${applicant.firstName} ${applicant.lastName}`.trim() || 'Anonymous applicant';
  const lenderWord = result.passCount === 1 ? 'lender' : 'lenders';

  return (
    <header className={s.card}>
      <div className={s.heroTop}>
        <span className={s.eyebrow}>
          Borrowing power · Nº {applicationId}
        </span>
        <span className={`${s.verdictPill} ${cfg.className}`}>{cfg.label}</span>
      </div>
      <p className={s.heroFigure}>{formatAud(result.borrowingLow)}</p>
      <p className={s.heroSub}>
        to <strong>{formatAud(result.borrowingHigh)}</strong> ·{' '}
        {result.passCount} {lenderWord} eligible
      </p>
      <p className={s.heroHeadline}>{result.rules.headline}</p>

      <div className={s.heroMeta}>
        <div className={s.heroMetaItem}>
          <span className={s.heroMetaLabel}>Applicant</span>
          <span>{fullName}</span>
        </div>
        <div className={s.heroMetaItem}>
          <span className={s.heroMetaLabel}>Issued</span>
          <span>{today}</span>
        </div>
        {purchase && (
          <div className={s.heroMetaItem}>
            <span className={s.heroMetaLabel}>Target</span>
            <span>
              {formatAud(purchase.purchasePrice)} · {purchase.propertyState}
            </span>
          </div>
        )}
        <div className={s.heroMetaItem}>
          <span className={s.heroMetaLabel}>Profile</span>
          <span>
            {applicant.country} · {applicant.citizenship.replace(/_/g, ' ')}
          </span>
        </div>
      </div>
    </header>
  );
};

export default BlueprintHeader;
